import styles from "./WizardLoadingScreen.module.scss";

export const WizardLoadingScreen = () => {
  return (
    <div className={styles.loadingContainer}>
      <div className={styles.loadingContent}>
        {/* Animated logo/icon */}
        <div className={styles.logoContainer}>
          <div className={styles.logo}>
            <div className={styles.logoInner}>
              <span className={styles.logoText}>📅</span>
            </div>
          </div>
        </div>

        {/* Loading text */}
        <div className={styles.textContainer}>
          <h2 className={styles.title}>Зареждане на системата</h2>
          <p className={styles.subtitle}>Моля, изчакайте...</p>
        </div>

        {/* Animated progress indicator */}
        <div className={styles.progressContainer}>
          <div className={styles.progressBar}>
            <div className={styles.progressFill}></div>
          </div>
          <div className={styles.dots}>
            <span className={styles.dot}></span>
            <span className={styles.dot}></span>
            <span className={styles.dot}></span>
          </div>
        </div>
      </div>
    </div>
  );
};
